<b-modal v-model="modal_requirement_092" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="w-100">
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <template v-if="phase === 'leftLampOn' || phase === 'rightLampOn'">
        <!-- キャンセルボタン -->
        <b-button size="sm" variant="outline-primary" @click="onCancelClicked" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_cancel') }}
        </b-button>
      </template>
      <template v-if="phase === 'start'|| phase === 'failed'">
        <!-- OKボタン -->
        <b-button size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <template v-if="phase === 'execution'">
        <!-- LH側、RH側ボタン -->
        <b-button size="sm" variant="primary" @click="onLhClicked" class="mx-2" :disabled="isLoading">
          {{ $t('individual.button_lh') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="onRhClicked" class="mx-2" :disabled="isLoading">
          {{ $t('individual.button_rl') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>